import React from 'react';
export function WhySection() {
  return <>
      <section className="border-b border-navy/10 bg-white px-3 py-4 sm:px-6" data-id="element-159" data-mp="h18whbyucjx2">
        <div className="mx-auto max-w-2xl" data-id="element-160" data-mp="13vt4m45kcu1o">
          <h2 className="text-center text-[1.1rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.6rem]" data-id="element-161" data-mp="18ucqk4k5q5u1">
            Stop trying to understand respiratory therapy from text alone
          </h2>
          <p className="mt-1.5 text-[0.8rem] leading-[1.4] sm:text-[0.95rem]" data-id="element-162" data-mp="1ikfswvd64w51">
            Not sure how respiratory findings connect to what's happening
            physiologically? Ventilator waveforms and loops all starting to
            look the same? ABGs, oxygen devices, breath sounds, pressures,
            alarms... what exactly should you be looking for? RESPIRATORY
            THERAPY VISUAL ATLAS™ gives you an organized visual study system to
            help you understand respiratory concepts, compare findings and
            recognize important patterns.
          </p>
          <p className="mt-1 text-center font-heading text-[0.72rem] font-extrabold uppercase tracking-wide text-teal sm:text-[0.85rem]" data-id="element-163" data-mp="2ifn4656nycwx">
            Assess. Compare. Recognize.
          </p>
        </div>
      </section>

      <section className="bg-clinical px-3 py-4 sm:px-6" data-id="element-164" data-mp="28p25khqzp8e0">
        <div className="mx-auto max-w-2xl" data-id="element-165" data-mp="28nhamr0rjnfm">
          <h2 className="text-center text-[1.05rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.5rem]" data-id="element-166" data-mp="24p1i67lwxmut">
            😩 Stop searching through different references for every
            respiratory topic
          </h2>
          <p className="mt-1.5 text-[0.8rem] leading-[1.4] sm:text-[0.95rem]" data-id="element-167" data-mp="2wg7k8tl71umq">
            You already study respiratory therapy. The problem is wasting time
            jumping between textbooks, lecture slides, websites and
            disconnected diagrams just to understand what you're actually
            seeing. Open the system, choose the respiratory topic and follow
            the organized visual references.
          </p>
          <p className="mt-1 text-center font-heading text-[0.72rem] font-extrabold uppercase tracking-wide text-teal sm:text-[0.85rem]" data-id="element-168" data-mp="1dgqdreg0zcte">
            Less searching. More structured learning.
          </p>
        </div>
      </section>
    </>;
}